<div class="transport-item-line row align-items-center">
  <div class="col-sm-3 col-xl-auto d-inline-flex align-items-center mw-xl-140">
    <div class="icon left-icon mr-2" [mdbTooltip]="transportTypology.label! | translate">
      <i [class]="transportTypology.icon"></i>
    </div>
    <ng-container *ngIf="handlingTypeItem">
      <div class="icon" [mdbTooltip]="handlingTypeItem.labelKey | translate">
        <i [class]="handlingTypeItem.icon"></i>
      </div>
      <span class="labelType px-2">{{ handlingTypeItem.labelKey | translate }}</span>
    </ng-container>
  </div>
  <div class="col-10 col-sm-7 col-xl">
    <div class="attributes row align-items-center flex-wrap">
      <div *ngIf="item.quantity" class="col-lg-5 col-xl-auto mw-xl-140">
        <span class="attribute">{{ 'LABEL.QUANTITY' | translate }}&nbsp;:</span>
        <span data-id-cypress="item-line-quantity">{{ item.quantity }}</span>
      </div>
      <ng-container *ngIf="item.width && item.length && item.maxHeight; else volumeBlock">
        <div class="col-lg-7 col-xl-auto mw-xl-220">
          <span class="attribute">{{ 'LABEL.DIMENSIONS' | translate }}&nbsp;:</span>
          <span data-id-cypress="item-line-size">{{ item.width | number: '1.0-2' }}x{{ item.length | measureUnit: 'length':true }}</span>
        </div>
        <div class="col-lg-5 col-xl-auto mw-xl-140">
          <span class="attribute">{{ 'LABEL.MAX_HEIGHT' | translate }}&nbsp;:</span>
          <span data-id-cypress="item-line-max-height">{{ item.maxHeight | measureUnit: 'length':true }}</span>
        </div>
      </ng-container>
      <ng-template #volumeBlock>
        <div class="col-lg-7 col-xl-auto mw-xl-220">
          <span class="attribute">{{ 'LABEL.VOLUME' | translate }}&nbsp;:</span>
          <span data-id-cypress="item-line-volume">{{ item.volume! | measureUnit: 'volume' }}</span>
        </div>
      </ng-template>
      <div class="col-lg-5 col-xl-auto mw-xl-140">
        <span class="attribute">{{ 'LABEL.WEIGHT' | translate }}&nbsp;:</span>
        <span data-id-cypress="item-line-weight">{{ item.weight! | measureUnit: 'weight' }}</span>
      </div>
    </div>
  </div>
  <div class="buttons col-2 col-xl-1">
    <div class="d-inline-flex align-items-center float-right">
      <jhi-bary-specific-button class="pr-1" type="editButton" (click)="editEvent.emit()"></jhi-bary-specific-button>
      <jhi-bary-specific-button type="trashButton" (click)="deleteEvent.emit()"></jhi-bary-specific-button>
    </div>
  </div>
</div>
